import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applyTheme(this.detectInitialTheme())
    window.addEventListener("message", this.handleMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.handleMessage)
  }

  handleMessage = (event) => {
    const theme = event.data?.theme
    if (theme) this.applyTheme(theme)
  }

  detectInitialTheme() {
    const parentTheme =
        window.parent?.document?.documentElement?.getAttribute("data-theme")
    if (parentTheme) return parentTheme

    const queryTheme = new URLSearchParams(window.location.search).get("theme")
    if (queryTheme) return queryTheme

    return document.documentElement.getAttribute("data-theme") || "light"
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
  }
}
